/**
 * Staff Service
 * API calls cho Staff module
 */

import api from "@/api/axios";
import { snakeToCamel } from "@/lib/utils";
import type {
  Staff,
  StaffListParams,
  VerifyPinPayload,
  VerifyPinResponse,
} from "@/types/staff";

// ============================================
// API ENDPOINTS
// ============================================

const STAFF_API_ENDPOINTS = {
  LIST: "/transactions/staffs",
  VERIFY_PIN: "/staffs/verify-pin",
} as const;

export const staffService = {
  /**
   * Get staff list
   * GET /staffs
   */
  getList: async (params: StaffListParams = {}): Promise<Staff[]> => {
    const queryParams: Record<string, string | number | undefined> = {
      page: params.page,
      limit: params.limit,
      search: params.search,
    };

    // Remove undefined values
    Object.keys(queryParams).forEach((key) => {
      if (queryParams[key] === undefined) {
        delete queryParams[key];
      }
    });

    const response = await api.get<unknown>(STAFF_API_ENDPOINTS.LIST, {
      params: queryParams,
    });
    const convertedData = snakeToCamel(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (response.data as Record<string, any>)?.data || [],
    );
    return convertedData;
  },

  /**
   * Verify staff PIN
   * POST /staffs/verify-pin
   */
  verifyPin: async (payload: VerifyPinPayload): Promise<VerifyPinResponse> => {
    const response = await api.post(STAFF_API_ENDPOINTS.VERIFY_PIN, payload);
    return response?.data?.data;
  },
};
